import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage33 from "../../../../assets/PDFViewerImages/PDFViewerImage33.jpg";
import PDFViewerImage34 from "../../../../assets/PDFViewerImages/PDFViewerImage34.jpg";
import PDFViewerImage35 from "../../../../assets/PDFViewerImages/PDFViewerImage35.jpg";

const Chapter18 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                 {/* Chapter 18 */}
                <section id="section18" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter18Title}</h2>

                    <p className="drivers-handbook-paragraph">
                       {language.chapter18Paragraph1}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage33} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter18Paragraph2}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage34} alt="Traffic Rules"/>
                    </div>


                    <h3 className="drivers-handbook-subheading"> {language.chapter18Subheading1}</h3>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter18Paragraph3}

                    </p>
                    <div className="image-box">
                        <img src={PDFViewerImage35} alt="Traffic Rules"/>
                    </div>


                </section>

        </>
    )

}

export default Chapter18;
